import { buildContactPayload } from '@/lib/contactForm/buildPayload';

/**
 * Monta payload para a API de contacto existente (/api/contact).
 * @param {object} values — campos validados do formulário de embaixadores
 * @param {string} language
 */
export function buildAmbassadorPayload(values, language) {
  const mensagem = [
    '--- Candidatura: Programa de Embaixadores WSJ ---',
    '',
    `País: ${values.country.trim()}`,
    `Cidade: ${values.city.trim()}`,
    `Como pretende indicar clientes: ${values.referralMethod.trim()}`,
    `Forma de pagamento (Pix/IBAN): ${values.paymentDetails.trim()}`,
    '',
    'Candidato aceitou os termos do programa.'
  ].join('\n');

  const base = buildContactPayload(
    {
      name: values.fullName,
      email: values.email,
      department: 'vendas',
      phone: values.whatsapp,
      message: mensagem
    },
    language
  );

  return {
    ...base,
    origem: 'programa-embaixadores'
  };
}

/** Texto completo para fallback WhatsApp quando a API não estiver disponível. */
export function buildAmbassadorWhatsappMessage(values) {
  return [
    'Olá! Gostaria de candidatar-me ao Programa de Embaixadores WSJ.',
    '',
    `Nome: ${values.fullName}`,
    `E-mail: ${values.email}`,
    `WhatsApp: ${values.whatsapp}`,
    `País: ${values.country}`,
    `Cidade: ${values.city}`,
    `Como pretendo indicar: ${values.referralMethod}`,
    `Pix/IBAN: ${values.paymentDetails}`,
    '',
    'Origem: programa-embaixadores'
  ].join('\n');
}

export function sanitizeAmbassadorDraft(raw) {
  const stripTags = (s) => s.replace(/<[^>]*>/g, '');
  return {
    fullName: typeof raw.fullName === 'string' ? raw.fullName.trim() : '',
    email: typeof raw.email === 'string' ? raw.email.trim() : '',
    whatsapp: raw.whatsapp == null || raw.whatsapp === '' ? '' : String(raw.whatsapp).trim(),
    country: typeof raw.country === 'string' ? stripTags(raw.country).trim() : '',
    city: typeof raw.city === 'string' ? stripTags(raw.city).trim() : '',
    referralMethod: typeof raw.referralMethod === 'string' ? stripTags(raw.referralMethod).trim() : '',
    paymentDetails: typeof raw.paymentDetails === 'string' ? stripTags(raw.paymentDetails).trim() : '',
    termsAccepted: !!raw.termsAccepted
  };
}
